import { render, staticRenderFns } from "./VPictureCropper.vue?vue&type=template&id=07052066&"
import script from "./VPictureCropper.vue?vue&type=script&lang=js&"
export * from "./VPictureCropper.vue?vue&type=script&lang=js&"
import style0 from "./VPictureCropper.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports